import { useState, useEffect } from "react";

import './Config.css';
import { SetModalData, SetModalState } from "interface/PopUp";
import { GetUserData, RegisterUserData } from "interface/Users";
import { GetDataPage, RegisterDataPage, UnRegisterDataPage } from "interface/Data";

import { SvgDelete, SvgFont, SvgImg, SvgSave, SvgSetaRight, SvgVideo, SvgVimeo, SvgYoutube } from "components/SvgFile";

import { Reg_Config } from "services/RegisterData";


import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import PopUp_Color from "components/PopUp/Color";

export default function Page_Config(props){

    const [ userId, setUserId ]     = useState(GetUserData('id'));
    const [ dataPage, setDataPage ] = useState(GetDataPage('config'));

    const [ bgImageNormal, setBgImageNormal ] = useState(GetDataPage('config').bg_image_normal);
    const [ bgImageNormalStatus, setBgImageNormalStatus ] = useState(false);
    const [ bgImageBlur, setBgImageBlur ] = useState(GetDataPage('config').bg_image_blur);
    const [ bgImageBlurStatus, setBgImageBlurStatus ] = useState(false);
    const [ bgVideo, setBgVideo ] = useState(GetDataPage('config').bg_video);
    const [ bgVideoStatus, setBgVideoStatus ] = useState(false);

    const [ timeRestart, setTimeRestart ] = useState(GetDataPage('config').time_restart);
    const [ logotipo, setLogotipo ] = useState(GetDataPage('config').logotipo);
    const [ statusLogo, setStatusLogo ] = useState(false);

    const [ floorplanTitle, setFloorplanTitle ] = useState(GetDataPage('config').floorplan_title);
    const [ floorplanFile, setFloorplanFile ] = useState(GetDataPage('config').floorplan_file);
    const [ floorplanStatus, setFloorplanStatus ] = useState(false);

    const [ title1, setTitle1 ] = useState(GetDataPage('config').title_1);
    const [ title2, setTitle2 ] = useState(GetDataPage('config').title_2);
    const [ title3, setTitle3 ] = useState(GetDataPage('config').title_3);
    const [ title4, setTitle4 ] = useState(GetDataPage('config').title_4);
    const [ title5, setTitle5 ] = useState(GetDataPage('config').title_5);
    const [ title6, setTitle6 ] = useState(GetDataPage('config').title_6);
    const [ color1, setColor1 ] = useState(GetDataPage('config').color_1);
    const [ color2, setColor2 ] = useState(GetDataPage('config').color_2);

    const [ font, setFont ] = useState(GetDataPage('config').list_fonte);

    let dataAtual = new Date();
    let day = dataAtual.getDate().toString().padStart(2, '0');
    let month = (dataAtual.getMonth() + 1).toString().padStart(2, '0');
    let year = dataAtual.getFullYear();

    function AddFile(type, value){
        // bg_image_normal
        if(type == 'bg_image_normal'){
            if(value){
                bgImageNormal(value);
                setBgImageNormalStatus(true);
            }else {
                bgImageNormal('');
                setBgImageNormalStatus(false);
            }
        }
        // bg_image_blur
        if(type == 'bg_image_blur'){
            if(value){
                setBgImageBlur(value);
                setBgImageBlurStatus(true);
            }else {
                setBgImageBlur('');
                setBgImageBlurStatus(false);
            }
        }
        // bg video
        if(type == 'bg_video'){
            if(value){
                setBgVideo(value);
                setBgVideoStatus(true);
            }else {
                setBgVideo('');
                setBgVideoStatus(false);
            }
        }
        // logotipo
        if(type == 'logotipo'){
            if(value){
                setLogotipo(value);
                setStatusLogo(true);
            }else {
                setLogotipo('');
                setStatusLogo(false);
            }
        }
        // floorplanFile
        if(type == 'floorplanFile'){
            if(value){
                setFloorplanFile(value);
                setFloorplanStatus(true);
            }else {
                setFloorplanFile('');
                setFloorplanStatus(false);
            }
        }
    }

    function OpenFile(type, file){
        SetModalData('ShowFile', { "typeFile": "alone", "type": type, "file": file });
        SetModalState('ShowFile', true);
    }

    function DeleteData(id, index, value){
        if(id == 0){
            const newData = [...font];
            newData.splice(index, 1);
            setFont(newData);

        }else {
            SetModalData('Confirmation', { "origin": "config", "type": "delete_data", "id" : id, "name": value, "setLoading": props.setLoading });
            SetModalState('Confirmation', true);
        }
    }

    function HandleData(type, index, value){
        const newData = [...font];
        if(type == 'fonte'){
            if(value){
                newData[index]['fonte']   = value;
                newData[index]['status'] = true;
            }else {
                newData[index]['fonte']   = value;
                newData[index]['status'] = false;
            }
        }else {
            newData[index][type] = value;
        }
        setFont(newData);
    }

    function SelectedColor(value){
        SetModalData('Color', { "setColorPage": value });
        SetModalState('Color', true)
    }

    function SaveData(event){
        event.preventDefault();
        props.setLoading(true);
        Reg_Config(userId, timeRestart, logotipo, floorplanTitle, floorplanFile, font, bgImageNormal, bgImageBlur, bgVideo, title1, title2, title3, title4, title5, title6, color1, color2, ()=>{ CallbackSuccess() }, ()=>{ CallbackError() });
    }

    function CallbackSuccess(){
        props.setLoading(false);
        SetModalData('ReturnResponse', { "page": "ok" });
        SetModalState('ReturnResponse', true);
    }

    function CallbackError(){
        props.setLoading(false);
        SetModalData('ReturnResponse', { "page": "erro" });
        SetModalState('ReturnResponse', true);
    }

    useEffect(()=>{
        RegisterUserData('id', setUserId);
        RegisterDataPage('config', setDataPage);

        return ()=>{
            UnRegisterDataPage('config', setDataPage);
        };
    }, []);

    useEffect(()=>{
        setDataPage(GetDataPage('config'));
        
        setBgImageNormal(GetDataPage('config').bg_image_normal);
        setBgImageNormalStatus(false);
        setBgImageBlur(GetDataPage('config').bg_image_blur);
        setBgImageBlurStatus(false);

        setBgVideo(GetDataPage('config').bg_video);
        setBgVideoStatus(false);

        setTimeRestart(GetDataPage('config').time_restart)
        setLogotipo(GetDataPage('config').logotipo);
        setStatusLogo(false);

        setFloorplanTitle(GetDataPage('config').floorplan_title);
        setFloorplanFile(GetDataPage('config').floorplan_file);
        setFloorplanStatus(false);

        setTitle1(GetDataPage('config').title_1);
        setTitle2(GetDataPage('config').title_2);
        setTitle3(GetDataPage('config').title_3);
        setTitle4(GetDataPage('config').title_4);
        setTitle5(GetDataPage('config').title_5);
        setTitle6(GetDataPage('config').title_6);
        setColor1(GetDataPage('config').color_1);
        setColor2(GetDataPage('config').color_2);

        setFont(GetDataPage('config').list_fonte);
    }, [dataPage]);

    return(
        <div className="Page_Config">
            <form onSubmit={ SaveData }>
                <div className="new_block">
                    <div className="div_name_page">
                        <div className="name_fixed">
                            Dashboard
                        </div>
                        <div className="show_icon">
                            <SvgSetaRight color="#6a6a6a" className="icons" />
                        </div>
                        <div className="name_page">
                            Dados do projeto
                        </div>
                    </div>
                    <button className="new_block_text">
                        <div className="">
                            <SvgSave color="#ffffff" className="icons" />
                        </div>
                        <div className="">
                            Salvar
                        </div>
                    </button>
                </div>

                <div className="show_page_data">
                    <div className="list_type_data">
                        <div className="type_title">Layout do PDF</div>
                    </div>
                    <div className="list_input_data">
                        <div class="div_input space_div show_data_text">
                            <div class="show_title">
                                <div className="">Primeira página</div>
                                <div className="div_select_color">
                                    Clique ao lado para escolher a cor
                                    <div className="div_color" style={ { background: color1 } } onClick={ ()=>{ SelectedColor(setColor1) } } /> 
                                </div>                               
                            </div>
                            <div className="list_input_data">
                                <div class="div_input img_" style={ { background: color1 } }>
                                    <div className="title_1">{ title1 }</div>
                                    <div className="title_2">{ title2 }</div>
                                    <div className="title_2">{ title3 }</div>
                                    <div className="title_3">{ title4 }</div>
                                    <div className="title_2">{ title5 == "" ? day + " | " + month + " | " + year : title5 }</div>
                                </div>
                                <div class="div_input space_div">
                                    <div className="list_input_data">
                                        <div class="div_input space_div">
                                            <input type="text" onChange={ (e)=>{ setTitle1(e.target.value) } } value={ title1 } maxLength="140" />
                                            <span className="name_input">Título 1</span>
                                        </div>
                                    </div>
                                    <div className="list_input_data">
                                        <div class="div_input space_div">
                                            <input type="text" onChange={ (e)=>{ setTitle2(e.target.value) } } value={ title2 } maxLength="140" />
                                            <span className="name_input">Título 2</span>
                                        </div>
                                    </div>
                                    <div className="list_input_data">
                                        <div class="div_input space_div">
                                            <input type="text" onChange={ (e)=>{ setTitle3(e.target.value) } } value={ title3 } maxLength="140" />
                                            <span className="name_input">Título 3</span>
                                        </div>
                                    </div>
                                    <div className="list_input_data">
                                        <div class="div_input space_div">
                                            <input type="text" onChange={ (e)=>{ setTitle4(e.target.value) } } value={ title4 } maxLength="140" />
                                            <span className="name_input">Título 4</span>
                                        </div>
                                    </div>
                                    <div className="list_input_data">
                                        <div class="div_input space_div">
                                            <input type="text" onChange={ (e)=>{ setTitle5(e.target.value) } } value={ title5 } maxLength="140" />
                                            <span className="name_input">Título 5, para pegar data atual deixe em branco</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 
                    <div className="list_input_data">
                        <div class="div_input space_div show_data_text">
                            <div class="show_title">Página que mostra os apartamentos</div>
                        </div>
                    </div> 
                    */}

                    <div className="list_input_data">
                        <div class="div_input space_div show_data_text">
                            <div class="show_title">
                                <div className="">Última página</div>
                                <div className="div_select_color">
                                    Clique ao lado para escolher a cor
                                    <div className="div_color" style={ { background: color2 } } onClick={ ()=>{ SelectedColor(setColor2) } } /> 
                                </div>      
                            </div>
                            <div className="list_input_data" style={ { alignItems: "flex-start" } }>
                                <div class="div_input img_" style={ { background: color2 } }>
                                    <div className="title_1">{ title6 }</div>
                                </div>
                                <div class="div_input space_div">
                                    <div className="list_input_data">
                                        <div class="div_input space_div">
                                            <input type="text" onChange={ (e)=>{ setTitle6(e.target.value) } } value={ title6 } maxLength="140" />
                                            <span className="name_input">Título</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="show_page_data">
                    <div className="list_type_data">
                        <div className="type_title">Background</div>
                    </div>
                    <div className="list_input_data">                        
                        <span className="div_input div_add_img">
                            <div className={ bgImageNormalStatus ? "new_file_add new_file_add_active" : "new_file_add" }>
                                <label>
                                    { bgImageNormalStatus ? "Imagem normal adicionado" : "Adicionar imagem normal" }
                                    <input type="file" onChange={ (e)=>{ AddFile('bg_image_normal', e.target.files[0]); } } accept="image/*" />
                                </label>
                            </div>
                            {
                                bgImageNormal !='' ?
                                <>
                                    <div className="delete_img_add" onClick={ ()=>{ AddFile('bg_image_normal', ''); } }>
                                        <SvgDelete className="icons" color="#ffffff" />
                                    </div>
                                    <div className="show_img_" onClick={ ()=>{ OpenFile('showImg', bgImageNormalStatus ? URL.createObjectURL(bgImageNormal) : bgImageNormal) } }>
                                        <SvgImg color="#324d6b" className="icons"/>
                                    </div>
                                </>
                                : null
                            }
                        </span>   

                        <span className="div_input div_add_img">
                            <div className={ bgImageBlurStatus ? "new_file_add new_file_add_active" : "new_file_add" }>
                                <label>
                                    { bgImageBlurStatus ? "Imagem blur adicionado" : "Adicionar imagem blur" }
                                    <input type="file" onChange={ (e)=>{ AddFile('bg_image_blur', e.target.files[0]); } } accept="image/*" />
                                </label>
                            </div>
                            {
                                bgImageBlur !='' ?
                                <>
                                    <div className="delete_img_add" onClick={ ()=>{ AddFile('bg_image_blur', ''); } }>
                                        <SvgDelete className="icons" color="#ffffff" />
                                    </div>
                                    <div className="show_img_" onClick={ ()=>{ OpenFile('showImg', bgImageBlurStatus ? URL.createObjectURL(bgImageBlur) : bgImageBlur) } }>
                                        <SvgImg color="#324d6b" className="icons"/>
                                    </div>
                                </>
                                : null
                            }
                        </span>

                        <span className="div_input div_add_img">
                            <div className={ bgVideoStatus ? "new_file_add new_file_add_active" : "new_file_add" }>
                                <label>
                                    { bgVideoStatus ? "Vídeo adicionado" : "Adicionar vídeo" }
                                    <input type="file" onChange={ (e)=>{ AddFile('bg_video', e.target.files[0]); } } accept="video/mp4,video/x-m4v,video/* video/webm, video/ogg" />
                                </label>
                            </div>
                            {
                                bgVideo !='' ?
                                <>
                                    <div className="delete_img_add" onClick={ ()=>{ AddFile('bg_video', ''); } }>
                                        <SvgDelete className="icons" color="#ffffff" />
                                    </div>
                                    <div className="show_img_" onClick={ ()=>{ OpenFile('video_local', bgVideoStatus ? URL.createObjectURL(bgVideo) : bgVideo) } }>
                                        <SvgVideo color="#324d6b" className="icons"/>
                                    </div>
                                </>
                                : null
                            }
                        </span>  
                    </div>
                </div>

                <div className="show_page_data">
                    <div className="list_type_data">
                        <div className="type_title">Dados fixos</div>
                    </div>
                    <div className="list_input_data">
                        <div className="div_input">
                            <input type="text" className="time_restart" onChange={ (e)=>{ setTimeRestart(e.target.value) } } value={ timeRestart.replace(/[^0-9]/g, '') } maxLength="3" required />
                            <span className="name_input">Time to restart</span>
                        </div>
                        <span className="div_input div_add_img">
                            <div className={ statusLogo ? "new_file_add new_file_add_active" : "new_file_add" }>
                                <label>
                                    { statusLogo ? "Logo fixo adicionado" : "Adicionar logo fixo" }
                                    <input type="file" onChange={ (e)=>{ AddFile('logotipo', e.target.files[0]); } } accept="image/*" />
                                </label>
                            </div>
                            {
                                logotipo !='' ?
                                <>
                                    <div className="delete_img_add" onClick={ ()=>{ AddFile('logotipo', ''); } }>
                                        <SvgDelete className="icons" color="#ffffff" />
                                    </div>
                                    {
                                        statusLogo ?
                                        <div className="show_img_" onClick={ ()=>{ OpenFile('showImg_local', URL.createObjectURL(logotipo)) } }>
                                            <SvgImg color="#324d6b" className="icons"/>
                                        </div> :
                                        <div className="show_img_" onClick={ ()=>{ OpenFile('showImg', logotipo) } }>
                                            <SvgImg color="#324d6b" className="icons"/>
                                        </div>
                                    }
                                </>
                                : null
                            }
                        </span>
                    </div>
                </div>

                <div className="show_page_data">
                    <div className="list_type_data">
                        <div className="type_title">Floorplan</div>
                    </div>
                    <div className="list_input_data">
                        <div className="div_input space_div">
                            <input type="text" onChange={ (e)=>{ setFloorplanTitle(e.target.value) } } value={ floorplanTitle } maxLength="140" />
                            <span className="name_input">Título</span>
                        </div>
                        <span className="div_input div_add_img">
                            <div className={ floorplanStatus ? "new_file_add new_file_add_active" : "new_file_add" }>
                                <label>
                                    { floorplanStatus ? "Logo fixo adicionado" : "Adicionar logo fixo" }
                                    <input type="file" onChange={ (e)=>{ AddFile('floorplanFile', e.target.files[0]); } } accept="image/*" />
                                </label>
                            </div>
                            {
                                floorplanFile !='' ?
                                <>
                                    <div className="delete_img_add" onClick={ ()=>{ AddFile('floorplanFile', ''); } }>
                                        <SvgDelete className="icons" color="#ffffff" />
                                    </div>
                                    {
                                        floorplanStatus ?
                                        <div className="show_img_" onClick={ ()=>{ OpenFile('showImg_local', URL.createObjectURL(floorplanFile)) } }>
                                            <SvgImg color="#324d6b" className="icons"/>
                                        </div> :
                                        <div className="show_img_" onClick={ ()=>{ OpenFile('showImg', floorplanFile) } }>
                                            <SvgImg color="#324d6b" className="icons"/>
                                        </div>
                                    }
                                </>
                                : null
                            }
                        </span>
                    </div>
                </div>

                <div className="show_page_data">
                    <div className="list_type_data">
                        <div className="type_title">Lista das fontes do site</div>
                        <div className="new_data_page" onClick={ ()=>{ setFont([...font, { "id": 0, "title": "", "fonte": "", "status": false }]) } }>
                            Adicionar nova fonte
                        </div>
                    </div>
                    {
                        font.length > 0 ?
                        <>
                            <div className="inf_date">
                                *Aceita apenas arquivos .otf e .ttf
                            </div>
                            {                                
                                font.map((elem, index)=>{
                                    return(
                                        <div className="list_input_data border_top" key={ index }>
                                            <div className="div_input space_div">
                                                <input type="text" onChange={ (e)=>{ HandleData('title', index, e.target.value) } } value={ elem.title } maxLength="140" />
                                                <span className="name_input">Nome da fonte</span>
                                            </div>
                                            <span className="div_input div_add_img">
                                                <div className={ elem.status ? "new_file_add new_file_add_active" : "new_file_add" }>
                                                    <label>
                                                        { elem.status ? "Fonte adicionada" : "Adicionar fonte" }
                                                        <input type="file" onChange={ (e)=>{ HandleData('fonte', index, e.target.files[0]); } } accept=".otf, .ttf" />
                                                    </label>
                                                </div>
                                                {
                                                    elem.fonte !='' ?
                                                    <>
                                                        <div className="delete_img_add" onClick={ ()=>{ HandleData('fonte', index, ''); } }>
                                                            <SvgDelete className="icons" color="#ffffff" />
                                                        </div>
                                                        {
                                                            elem.status ?
                                                            <a href={ URL.createObjectURL(elem.fonte) } className="show_img_">
                                                                <SvgFont color="#324d6b" className="icons"/>
                                                            </a> :
                                                            <a href={ elem.fonte } className="show_img_">
                                                                <SvgFont color="#324d6b" className="icons"/>
                                                            </a>
                                                        }
                                                    </>
                                                    : null
                                                }
                                            </span>
                                            <div className="div_input" onClick={ ()=>{ DeleteData(elem.id, index, elem.title); } }>
                                                <SvgDelete color="#f00000" className="icons" />
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </> 
                        : null
                    }
                </div>
            </form>
            <PopUp_Color />
        </div>
    )
}